import { IPartsConfigSchema } from "../../types/IPartsConfigSchema";

export function partsConfig(
  BAY_DEPTH: number,
  MAX_CELL: number,
  MIN_CELL: number,
): IPartsConfigSchema {
  const BAY_DEPTH_SEP_X = BAY_DEPTH - 0.0061;

  return {
    Nose: {
      parts: [
        "Nose-Upper",
        "Nose-Lower",
        "Nose-Bridge",
        "Anchor-Left",
        "Anchor-Right",
      ],
    },
    Tail: {
      parts: [
        {
          name: "Tail-Holder",
          isGroup: true,
          parts: [
            {
              min: 4,
              max: 11,
              part: "Tail-4-11-1P1R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "1P1R",
            },
            {
              min: 4,
              max: 11,
              part: "Tail-4-11-1P2R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "1P2R",
            },
            {
              min: 4,
              max: 11,
              part: "Tail-4-11-2P1R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "2P1R",
            },
            {
              min: 4,
              max: 11,
              part: "Tail-4-11-2P2R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "2P2R",
            },
            {
              min: 12,
              max: 19,
              part: "Tail-12-19-1P1R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "1P1R",
            },
            {
              min: 12,
              max: 19,
              part: "Tail-12-19-1P2R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "1P2R",
            },
            {
              min: 12,
              max: 19,
              part: "Tail-12-19-2P1R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "2P1R",
            },
            {
              min: 12,
              max: 19,
              part: "Tail-12-19-2P2R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "2P2R",
            },
            {
              min: 20,
              max: 27,
              part: "Tail-20-27-1P1R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "1P1R",
            },
            {
              min: 20,
              max: 27,
              part: "Tail-20-27-1P2R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "1P2R",
            },
            {
              min: 20,
              max: 27,
              part: "Tail-20-27-2P1R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "2P1R",
            },
            {
              min: 20,
              max: 27,
              part: "Tail-20-27-2P2R",
              partName: "Tail-Obj",
              isOption: true,
              resetPos: true,
              globalGroup: "2P2R",
            },
            {
              name: "Tail-Module-0",
              isGroup: true,
              resetPos: true,
              parts: [
                {
                  min: 4,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F0",
                },
                {
                  min: 4,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper-Side",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F0",
                },
                {
                  min: 4,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper-Diagonal",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F0",
                },
                {
                  min: 4,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Floor",
                  isOption: true,
                  resetPos: true,
                  globalGroup: "Deck",
                },

                {
                  min: 4,
                  max: 4,
                  part: "MSLT-0-4-11-00",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 5,
                  max: 5,
                  part: "MSLT-0-4-11-01",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 6,
                  max: 6,
                  part: "MSLT-0-4-11-02",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 7,
                  max: 7,
                  part: "MSLT-0-4-11-03",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 8,
                  max: 8,
                  part: "MSLT-0-4-11-04",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 9,
                  max: 9,
                  part: "MSLT-0-4-11-05",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 10,
                  max: 10,
                  part: "MSLT-0-4-11-06",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 11,
                  max: 11,
                  part: "MSLT-0-4-11-07",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
              ],
            },

            {
              name: "Tail-Module-1",
              isGroup: true,
              resetPos: { x: BAY_DEPTH, y: 0, z: 0 },
              parts: [
                {
                  min: 12,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F1",
                },
                {
                  min: 12,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper-Side",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F1",
                },
                {
                  min: 12,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper-Diagonal",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F1",
                },
                {
                  min: 12,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Floor",
                  isOption: true,
                  resetPos: true,
                  globalGroup: "Deck",
                },

                {
                  min: 12,
                  max: 12,
                  part: "MSLT-0-12-19-08",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 13,
                  max: 13,
                  part: "MSLT-0-12-19-09",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 14,
                  max: 14,
                  part: "MSLT-0-12-19-10",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 15,
                  max: 15,
                  part: "MSLT-0-12-19-11",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 16,
                  max: 16,
                  part: "MSLT-0-12-19-12",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 17,
                  max: 17,
                  part: "MSLT-0-12-19-13",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 18,
                  max: 18,
                  part: "MSLT-0-12-19-14",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 19,
                  max: 19,
                  part: "MSLT-0-12-19-15",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },

                {
                  min: 12,
                  max: 12,
                  part: "MSLT-1-12-19-08",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 13,
                  max: 13,
                  part: "MSLT-1-12-19-09",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 14,
                  max: 14,
                  part: "MSLT-1-12-19-10",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 15,
                  max: 15,
                  part: "MSLT-1-12-19-11",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 16,
                  max: 16,
                  part: "MSLT-1-12-19-12",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 17,
                  max: 17,
                  part: "MSLT-1-12-19-13",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 18,
                  max: 18,
                  part: "MSLT-1-12-19-14",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 19,
                  max: 19,
                  part: "MSLT-1-12-19-15",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
              ],
            },

            {
              name: "Tail-Module-2",
              isGroup: true,
              resetPos: { x: BAY_DEPTH * 2, y: 0, z: 0 },
              parts: [
                {
                  min: 20,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F2",
                },
                {
                  min: 20,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper-Side",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F2",
                },
                {
                  min: 20,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Separator-Upper-Diagonal",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
                  globalGroup:
                    "Separators,Separators-Upper,Separators-Upper-F2",
                },
                {
                  min: 20,
                  minCalc: MIN_CELL,
                  max: 27,
                  part: "Module-Floor",
                  isOption: true,
                  resetPos: true,
                  globalGroup: "Deck",
                },

                {
                  min: 20,
                  max: 20,
                  part: "MSLT-0-20-27-16",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 21,
                  max: 21,
                  part: "MSLT-0-20-27-17",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 22,
                  max: 22,
                  part: "MSLT-0-20-27-18",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 23,
                  max: 23,
                  part: "MSLT-0-20-27-19",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 24,
                  max: 24,
                  part: "MSLT-0-20-27-20",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 25,
                  max: 25,
                  part: "MSLT-0-20-27-21",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 26,
                  max: 26,
                  part: "MSLT-0-20-27-22",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 27,
                  max: 27,
                  part: "MSLT-0-20-27-23",
                  isOption: true,
                  resetPos: { x: -BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },

                {
                  min: 20,
                  max: 20,
                  part: "MSLT-1-20-27-16",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 21,
                  max: 21,
                  part: "MSLT-1-20-27-17",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 22,
                  max: 22,
                  part: "MSLT-1-20-27-18",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 23,
                  max: 23,
                  part: "MSLT-1-20-27-19",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 24,
                  max: 24,
                  part: "MSLT-1-20-27-20",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 25,
                  max: 25,
                  part: "MSLT-1-20-27-21",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 26,
                  max: 26,
                  part: "MSLT-1-20-27-22",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 27,
                  max: 27,
                  part: "MSLT-1-20-27-23",
                  isOption: true,
                  resetPos: { x: 0, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },

                {
                  min: 20,
                  max: 20,
                  part: "MSLT-2-20-27-16",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 21,
                  max: 21,
                  part: "MSLT-2-20-27-17",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 22,
                  max: 22,
                  part: "MSLT-2-20-27-18",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 23,
                  max: 23,
                  part: "MSLT-2-20-27-19",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 24,
                  max: 24,
                  part: "MSLT-2-20-27-20",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 25,
                  max: 25,
                  part: "MSLT-2-20-27-21",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 26,
                  max: 26,
                  part: "MSLT-2-20-27-22",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
                {
                  min: 27,
                  max: 27,
                  part: "MSLT-2-20-27-23",
                  isOption: true,
                  resetPos: { x: BAY_DEPTH_SEP_X, y: -0.06, z: 0 },
                  globalGroup: "Separators",
                },
              ],
            },
          ],
        },
      ],
      extraModules: [
        { min: 4, max: 11, n: 1 },
        { min: 12, max: 19, n: 2 },
        { min: 20, max: 27, n: 3 },
      ],
      removeAndRename: [
        {
          min: 4,
          max: 4,
          name: "MSLT-0-4-11-00",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 5,
          max: 5,
          name: "MSLT-0-4-11-01",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 6,
          max: 6,
          name: "MSLT-0-4-11-02",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 7,
          max: 7,
          name: "MSLT-0-4-11-03",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 8,
          max: 8,
          name: "MSLT-0-4-11-04",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 9,
          max: 9,
          name: "MSLT-0-4-11-05",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 10,
          max: 10,
          name: "MSLT-0-4-11-06",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 11,
          max: 11,
          name: "MSLT-0-4-11-07",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 12,
          max: 12,
          name: "MSLT-0-12-19-08",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 13,
          max: 13,
          name: "MSLT-0-12-19-09",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 14,
          max: 14,
          name: "MSLT-0-12-19-10",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 15,
          max: 15,
          name: "MSLT-0-12-19-11",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 16,
          max: 16,
          name: "MSLT-0-12-19-12",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 17,
          max: 17,
          name: "MSLT-0-12-19-13",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 18,
          max: 18,
          name: "MSLT-0-12-19-14",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 19,
          max: 19,
          name: "MSLT-0-12-19-15",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 20,
          max: 20,
          name: "MSLT-0-20-27-16",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 21,
          max: 21,
          name: "MSLT-0-20-27-17",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 22,
          max: 22,
          name: "MSLT-0-20-27-18",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 23,
          max: 23,
          name: "MSLT-0-20-27-19",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 24,
          max: 24,
          name: "MSLT-0-20-27-20",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 25,
          max: 25,
          name: "MSLT-0-20-27-21",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 26,
          max: 26,
          name: "MSLT-0-20-27-22",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 27,
          max: 27,
          name: "MSLT-0-20-27-23",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-0",
        },
        {
          min: 12,
          max: 12,
          name: "MSLT-1-12-19-08",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 13,
          max: 13,
          name: "MSLT-1-12-19-09",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 14,
          max: 14,
          name: "MSLT-1-12-19-10",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 15,
          max: 15,
          name: "MSLT-1-12-19-11",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 16,
          max: 16,
          name: "MSLT-1-12-19-12",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 17,
          max: 17,
          name: "MSLT-1-12-19-13",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 18,
          max: 18,
          name: "MSLT-1-12-19-14",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 19,
          max: 19,
          name: "MSLT-1-12-19-15",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 20,
          max: 20,
          name: "MSLT-1-20-27-16",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 21,
          max: 21,
          name: "MSLT-1-20-27-17",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 22,
          max: 22,
          name: "MSLT-1-20-27-18",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 23,
          max: 23,
          name: "MSLT-1-20-27-19",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 24,
          max: 24,
          name: "MSLT-1-20-27-20",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 25,
          max: 25,
          name: "MSLT-1-20-27-21",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 26,
          max: 26,
          name: "MSLT-1-20-27-22",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 27,
          max: 27,
          name: "MSLT-1-20-27-23",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-1",
        },
        {
          min: 20,
          max: 20,
          name: "MSLT-2-20-27-16",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
        {
          min: 21,
          max: 21,
          name: "MSLT-2-20-27-17",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
        {
          min: 22,
          max: 22,
          name: "MSLT-2-20-27-18",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
        {
          min: 23,
          max: 23,
          name: "MSLT-2-20-27-19",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
        {
          min: 24,
          max: 24,
          name: "MSLT-2-20-27-20",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
        {
          min: 25,
          max: 25,
          name: "MSLT-2-20-27-21",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
        {
          min: 26,
          max: 26,
          name: "MSLT-2-20-27-22",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
        {
          min: 27,
          max: 27,
          name: "MSLT-2-20-27-23",
          rename: "Module-Separator-Lower",
          parent: "Tail-Module-2",
        },
      ],
    },
    ModuleSeparators: {
      parts: [
        {
          name: "Separators",
          isGroup: true,
          parts: [
            {
              min: 4,
              max: 4,
              part: "Module-Lower-Separator-00",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 5,
              max: 5,
              part: "Module-Lower-Separator-01",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 6,
              max: 6,
              part: "Module-Lower-Separator-02",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 7,
              max: 7,
              part: "Module-Lower-Separator-03",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 8,
              max: 8,
              part: "Module-Lower-Separator-04",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 9,
              max: 9,
              part: "Module-Lower-Separator-05",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 10,
              max: 10,
              part: "Module-Lower-Separator-06",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 11,
              max: 11,
              part: "Module-Lower-Separator-07",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 12,
              max: 12,
              part: "Module-Lower-Separator-08",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 13,
              max: 13,
              part: "Module-Lower-Separator-09",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 14,
              max: 14,
              part: "Module-Lower-Separator-10",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 15,
              max: 15,
              part: "Module-Lower-Separator-11",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 16,
              max: 16,
              part: "Module-Lower-Separator-12",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 17,
              max: 17,
              part: "Module-Lower-Separator-13",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 18,
              max: 18,
              part: "Module-Lower-Separator-14",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 19,
              max: 19,
              part: "Module-Lower-Separator-15",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 20,
              max: 20,
              part: "Module-Lower-Separator-16",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 21,
              max: 21,
              part: "Module-Lower-Separator-17",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 22,
              max: 22,
              part: "Module-Lower-Separator-18",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 23,
              max: 23,
              part: "Module-Lower-Separator-19",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 24,
              max: 24,
              part: "Module-Lower-Separator-20",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 25,
              max: 25,
              part: "Module-Lower-Separator-21",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 26,
              max: 26,
              part: "Module-Lower-Separator-22",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },
            {
              min: 27,
              max: 27,
              part: "Module-Lower-Separator-23",
              partName: "Module-Separator-Lower",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators",
            },

            {
              min: 4,
              max: 27,
              part: "Module-Separator-Upper",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators,Separators-Upper",
            },
            {
              min: 4,
              max: 27,
              part: "Module-Separator-Upper-Diagonal",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators,Separators-Upper",
            },
            {
              min: 4,
              max: 27,
              part: "Module-Separator-Upper-Side",
              isOption: true,
              resetPos: { x: BAY_DEPTH_SEP_X, y: 0, z: 0 },
              globalGroup: "Separators,Separators-Upper",
            },
          ],
        },
      ],
    },
    ModuleBody: {
      parts: [
        {
          min: 4,
          max: 27,
          part: "Module-Floor",
          isOption: true,
          resetPos: true,
          globalGroup: "Deck",
        },
        {
          min: 4,
          max: 27,
          part: "Module-Lower",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
      ],
    },
    BridgeAbove: {
      parts: [
        {
          min: 4,
          max: 13,
          part: "Bridge-1st-floor-4-13",
          partName: "Bridge-1st-floor",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 14,
          max: 27,
          part: "Bridge-1st-floor-14-28",
          partName: "Bridge-1st-floor",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 13,
          part: "Bridge-last-floor-4-13",
          partName: "Bridge-last-floor",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 14,
          max: 27,
          part: "Bridge-last-floor-14-28",
          partName: "Bridge-last-floor",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 13,
          part: "Bridge-nth-floor-4-13",
          partName: "Bridge-nth-floor",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 14,
          max: 27,
          part: "Bridge-nth-floor-14-28",
          partName: "Bridge-nth-floor",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 27,
          part: "Smoke-Funnel-Lower-Single-14-28",
          partName: "Bridge-Smoke-Lower",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 27,
          part: "Smoke-Funnel-Upper-Single-14-28",
          partName: "Bridge-Smoke-Upper",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
      ],
    },
    Smoke: {
      parts: [
        {
          min: 4,
          max: 27,
          part: "Smoke-Funnel-Base-Single",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 27,
          part: "Smoke-Funnel-Lower-Single-14-28",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 27,
          part: "Smoke-Funnel-Upper-Single-14-28",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
      ],
    },
    Crane: {
      parts: [
        {
          min: 4,
          max: 27,
          part: "Crane-Base",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 27,
          part: "Crane-Stair-Module",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
        {
          min: 4,
          max: 27,
          part: "Crane-Top",
          isOption: true,
          resetPos: true,
          globalGroup: undefined,
        },
      ],
    },
  };
}
